import { TableRow, TableCell } from "@/components/ui/table";
import { Table, flexRender } from "@tanstack/react-table";
import { InvitationsTable, invitationsColumns } from "./InvitationsColumns";

type Props<TData> = {
  table: Table<TData>;
  rowClickAction?: () => void;
  isFiltered: boolean;
};

export const InvitationsTableContent = <TData extends InvitationsTable>({
  table,
  isFiltered,
  rowClickAction
}: Props<TData>) => {
  return table.getRowModel().rows?.length ? (
    table.getRowModel().rows.map((row) => {
      return (
        <TableRow
          onClick={rowClickAction}
          className="h-16 cursor-pointer"
          key={row.id}
          data-state={row.getIsSelected() && "selected"}
        >
          {row.getVisibleCells().map((cell) => (
            <TableCell className="first:w-16" key={cell.id}>
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </TableCell>
          ))}
        </TableRow>
      );
    })
  ) : (
    <TableRow>
      <TableCell
        colSpan={invitationsColumns.length}
        className="h-16 text-center"
      >
        {isFiltered
          ? "No invitations could be found."
          : "Your organization has no pending invitations."}
      </TableCell>
    </TableRow>
  );
};
